import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, CURRENT_ENV } from '../../../../utils';
import {
  APP_ID,
  APP_VERSION,
} from '../../../../utils/constants/request-related';

let bucketName = '';
if (CURRENT_ENV === 'STAGING' || CURRENT_ENV === 'PRODUCTION') {
  bucketName = `esdoc`;
} else {
  bucketName = `esqadoc-qa`;
}

export const LMT_ENHCMT_s3FileUpload_API_CALL = createAsyncThunk(
  'LMT_ENHCMT_s3FileUpload_API_CALL',
  async (s3SaveFileReqPayload, { getState, rejectWithValue, dispatch }) => {
    dispatch({ type: 'LMT_ENHCMT_s3FileUpload_API_CALL/pending', payload: {} });
    const { payload, index, successFn, errorFn } = s3SaveFileReqPayload;
    const { authorization, customerId, folder_name, file_name, inputStream } =
      payload;
    SecureClient({
      isEncrypted: true,
      customerId: null,
      route: 's3savefilenew',
      payload: {
        appId: APP_ID,
        appVersion: APP_VERSION,
        bucket_name: bucketName,
        folder_name,
        file_name,
        inputStream,
        content_type: 'application/pdf',
      },
      otherPayloadDetailsPresent: true,
      headers: { authorization, customerid: customerId },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const s3SaveFileResponse = res;
        dispatch({
          type: 'LMT_ENHCMT_s3FileUpload_API_CALL/fulfilled',
          payload: { response: s3SaveFileResponse, index },
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({
          type: 'LMT_ENHCMT_s3FileUpload_API_CALL/rejected',
          payload: err,
        });
      },
    });
  }
);

export const LMT_ENHCMT_s3FileUpload_API_CALL_extrareducer = {
  [LMT_ENHCMT_s3FileUpload_API_CALL.pending]: (state, action) => {
    state.s3FileUploadAPICall.isLoading = true;
  },
  [LMT_ENHCMT_s3FileUpload_API_CALL.fulfilled]: (state, action) => {
    state.s3FileUploadAPICall.isLoading = false;

    state.s3FileUploadAPICall.isSuccess = true;
    state.s3FileUploadAPICall.isError = false;
    if (action.payload) {
      const { response, index } = action.payload;

      state.s3FileUploadAPICall.response = response;
      state.s3FileUploadAPICall.uploadFileResponses[index] = response;
    }
  },
  [LMT_ENHCMT_s3FileUpload_API_CALL.rejected]: (state, action) => {
    state.s3FileUploadAPICall.isLoading = false;

    state.s3FileUploadAPICall.isSuccess = false;
    state.s3FileUploadAPICall.isError = true;
    state.s3FileUploadAPICall.response = action.payload;
  },
};
